<template>
  <div class="preview-wrap">
    <div class="tem-pdf-wrap">
      <header class="tem-common-header">
        <!-- 公司名称 -->
        <h1 class="tem-name">{{ info.cName }}</h1>
        <div class="tem-logo">
          <!-- 公司logo -->
          <img v-if="form.company_logo" :src="form.company_logo" alt="company logo" />
        </div>
        <div class="tem-version right">{{ info.version }}</div>
      </header>
      <main>
        <div class="onjob-content">
          <p v-if="lang === 'en'" class="margin-bottom">Date: {{ $util.parseTime(new Date(), '{y}-{m}-{d}') }}</p>
          <slot></slot>
        </div>
      </main>
      <!-- 底部 -->
      <footer>
        <div class="tem-concat">
          <p>{{ lang === 'en' ? 'Tel' : 'โทร.' }}: {{ form.c_mobile }}</p>
          <p>email: {{ form.email }}</p>
        </div>
        <!-- 页脚 -->
        <div class="tem-footer">
          <!-- 公司地址 -->
          <p>{{ lang === 'en' && form.address_en ? form.address_en : form.address }}</p>
          <p>
            <span>T: {{ form.c_mobile }}</span>
            <span style="display: inline-block; margin-left: 20px" v-if="form.c_site"> W: {{ form.c_site }}</span>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      default: 'th'
    }
  },
  computed: {
    info() {
      const { lang, form } = this
      const year = +this.$util.parseTime(new Date(), '{y}')
      const cName = lang === 'th' ? form.c_name_th : form.c_name_en
      // 语言表示
      const langS = lang === 'th' ? form.th_language : form.en_language
      // 企业简称
      const shortName = (lang === 'th' ? form.c_short_name_th : form.c_short_name_en) || ''
      // 日期时间
      const formateDate = String(form.date_format === 1 && lang === 'th' ? year + 543 : year)
      return {
        cName,
        // 模版编号
        // 企业简称-语言标识00000-年份
        version: (shortName ? shortName + '-' : shortName) + langS + '00000' + '-' + formateDate
      }
    }
  }
}
</script>
